import React, { useEffect, useState } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import Modal from '@material-ui/core/Modal'
import Api from '../../../pages/api/api'
import styles from './buy_pdf_modal.module.css'
import { NativeSelectPayType } from '../../modules/naive_select_pay_type/native_select_pay_type'
import { NativeSelectTransactionCurrency } from '../native_select_transaction_currency/native_select_transaction_currency'
import { CircularProgress, Grid } from '@material-ui/core'
import strings from '../../strings/strings.json'
import { useRouter } from 'next/router'
import { NumSeperator } from '../../modules/num_separator/num_separator'

const useStyles = makeStyles((theme) => ({
    paper: {
        position: "absolute",
        width: 800,
        backgroundColor: "#ffffff",
        border: 0,
        boxShadow: "0 10px 80px 2px rgba(77, 72, 103, 0.15)",
        padding: theme.spacing(2, 4, 3),
        paddingBottom: "50px",
        left: "50%",
        top: "50%",
        outline: 0,
        transform: "translate(-50%, -50%)",
        borderRadius: "15px",

        [theme.breakpoints.down('sm')]: {
            width: 280,
            padding: 10
        },
        [theme.breakpoints.up('sm')]: {
            width: 800,
        }
    }
}))

export default function CustomModal(props) {
    const router = useRouter()
    const classes = useStyles()
    const [payType, setPayType] = useState('mellat')
    const [loading, setLoading] = useState(false)
    const [payMode, setPayMode] = useState(false)
    const [PDFPrice, setPDFPrice] = useState(0)


    useEffect(() => {
        Api.getPDFPrice()
            .then(result => {
                setPDFPrice(result.price)
            })
    }, [])

    const paymentOnClickHandler = () => {
        localStorage.removeItem("planInfo")
        localStorage.setItem("pdfInfo", JSON.stringify(props.data))
        setLoading(true)
        Api.paymentBuy({
            "gateway_name": payType,
            "transaction_currency": "rial",
            "product_type": "pdf",
            "app_owner_email": props.email,
            "hash": props.data.sha256
        })
            .then(result => {
                setLoading(false)
                window.open(`https://bpm.shaparak.ir/pgwchannel/result.mellat?RefId=${result.payment_url}`, "_self")
            })
            .catch(err => {
                setLoading(false)
                props.setSnack(true, "error",
                    <div>
                        <div>{err.message}</div>
                        {
                            err.info !== undefined &&
                            <div>{err.info}</div>
                        }
                    </div>
                )
            })
    }

    const renderDetails = (title1, title2, desc, btn_title, btn_style) => {
        return (
            <div className={styles.render_details_container}>
                <span className={`${btn_title !== strings.fileDetails_selectPlan ? `${styles.title1_pdf_only} ${styles.title1} ` : styles.title1}`}>{title1}</span>
                <span className={styles.title2}>{title2}</span>
                <span className={styles.title_desc}>{desc}</span>
                <button className={btn_style} onClick={() => btn_title === strings.fileDetails_selectPlan ? router.push('/plans') : setPayMode(true)}>{btn_title}</button>
            </div>
        )
    }

    return (
        <Modal
            disableScrollLock={true}
            open={props.open}
        >

            <div className={classes.paper}>
                <div className={styles.header} >
                    <img className={styles.close} onClick={() => props.closeModal()} src="/assets/icons/close.svg" alt="close" />
                    {
                        payMode &&
                        <img className={styles.back} onClick={() => setPayMode(false)} src="/assets/icons/back.png" alt="back" />
                    }
                </div>
                {
                    !payMode ?
                        <div>
                            <div className={styles.title_container}>
                                <span className={styles.buy_pdf_title}>{strings.fileDetail_downloadPDFBuy}</span>
                                <span className={styles.buy_pdf_subTitle}>{strings.fileDetail_downloadPDFBuyDes}</span>
                            </div>
                            <Grid container>
                                <Grid item sm={12} md={6} lg={6}>
                                    <div className={styles.pdf_only_container}>
                                        {renderDetails(`${NumSeperator(PDFPrice)} ${strings.plans_toman}`, strings.fileDetails_buyOnly, strings.fileDetails_buyOnlyDesc, strings.general_buy, `${styles.btn} ${styles.buy_only_btn}`)}
                                    </div>
                                </Grid>
                                <Grid item sm={12} md={6} lg={6}>
                                    <div >
                                        {renderDetails(strings.fileDetails_selectPlan, strings.fileDetails_accessAll, strings.fileDetails_accessAllDes, strings.fileDetails_selectPlan, `${styles.btn} ${styles.select_plan_btn}`)}
                                    </div>
                                </Grid>
                            </Grid>
                        </div>
                        :
                        <div>
                            <div className={styles.title}>{strings.plans_paymentMethodTitle}</div>
                            <div className={styles.subTitle}>{strings.plans_paymentMethodSubTitle}</div>
                            <div className={`${styles.currency_container} center`}> <NativeSelectTransactionCurrency setPayType={(value) => setPayType(value)} /></div>
                            <div className={styles.pay_btn_container}>
                                {
                                    loading ?
                                        <CircularProgress size={35} />
                                        :
                                        <button className={styles.pay_btn} onClick={() => paymentOnClickHandler()}>{strings.plans_pay} {<span className={styles.price_span}>{`${PDFPrice} ${strings.plans_toman}`}</span>}</button>
                                }
                            </div>
                        </div>
                }
            </div>
        </Modal>
    )
}
